import React, { useState } from "react"
// import { Link } from "gatsby"
import { Headline, CirclesBurstSet, CTA } from "@shared"
import { css } from "@jsUtils"
import { URLS, CONTENT } from "@data"

import { PageSection } from "../PageSection"

import Styles from "./ctaModule.module.scss"

const { GET_IN_TOUCH } = CONTENT
const { DEFAULT } = GET_IN_TOUCH
const { defHeadline, defSubhead, defCtaCopy } = DEFAULT

/**
 * Podcast section
 * @param {object} props - React props
 */
const CTAModule = props => {
  const {
    color,
    theme,
    headline,
    subhead,
    ctaLink,
    ctaCopy,
    hasCircles,
    reducedHeadline,
    onClick,
    isBtn,
    inverseSymbol
  } = props
  const [ready, setReady] = useState(false)
  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      {hasCircles ? <CirclesBurstSet color={color} ready={ready} /> : null}
      <div className={Styles.content}>
        <Headline
          size={2}
          className={`${Styles.headline} ${reducedHeadline ? Styles.reduced : null}`}
        >
          {headline || defHeadline}
        </Headline>
        <p className={Styles.subhead}>{subhead || defSubhead}</p>
        <CTA
          ready={ready}
          className={Styles.storyCTA}
          content="chevron"
          color={color}
          to={!onClick ? `${ctaLink || URLS.CONTACT}` : null}
          onClick={onClick || null}
          isBtn={isBtn}
          theme={theme}
        >
          {ctaCopy || defCtaCopy}
        </CTA>
      </div>
    </PageSection>
  )
}

export default CTAModule
